import Image from "next/image";
import styles from "./yarn-widget.module.css";

export const YarnWidget = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.spread}>{children}</div>;
};

export const Colors = ({
  total,
  swatchUrl
}: {
  total: number;
  swatchUrl?: string;
}) => {
  return (
    <div className={styles.circles}>
      <div className={styles.imageWrapper}>
        {swatchUrl && (
          <Image
            loading="lazy"
            alt="farge"
            width={12}
            height={12}
            src={swatchUrl}
            className={styles.circleImage}
          />
        )}
      </div>
      {!!total && total > 1 && <strong>{`+${total - 1}`}</strong>}
    </div>
  );
};

export const WeightAndLength = ({
  children
}: {
  children: React.ReactNode;
}) => {
  return <p className={styles.weightAndLength}>{children}</p>;
};
